import { conditions } from "../../../../../helpers";
import { IBookmark, ConditionName } from "../../../../../interfaces";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { setBookmarksPopover } from "../../../../../redux/slices/popoversSlice";
import Popover from "../popover/popover";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const BookmarkCard = dynamic(() => import("./bookmarkCard"));
const EmptyStateBookmarksIcon = dynamic(() => import("../../icon-components/emptyStateBookmarkIcon"));
const TabNavigator = dynamic(() => import("../tabNavigator/TabNavigator"));

const BookmarksPopover = () => {

    const dispatch = useAppDispatch();
    const { bookmarks } = useAppSelector(({ user: { bookmarks } }) => ({ bookmarks }), shallowEqual);
    useAppSelector(({ popovers: { bookmarksPopover } }) => ({ bookmarksPopover }), shallowEqual);
    useAppSelector(({ videoData: { isComplexDesktop, isComplexPortrait } }) => ({ isComplexDesktop, isComplexPortrait }), shallowEqual);

    return (
        <Popover
            type="modal"
            status={conditions(ConditionName.showBookmarksPopover)}
            onClose={() => dispatch(setBookmarksPopover(false))}
            isHeader={conditions(ConditionName.isComplexDesktop)}
            headerTitle={conditions(ConditionName.isComplexDesktop) ? "لیست ذخیره‌شده‌ها" : ""}
            isBlurBackground={conditions(ConditionName.isComplexDesktop)}
            isFullScreen={conditions(ConditionName.isComplexPortrait)}
            classNames={`${conditions(ConditionName.isComplexDesktop) ? "pl-w-[800px] pl-max-w-[90vw] pl-h-[500px] pl-max-h-[90vw] !pl-bg-white dark:!pl-bg-dark-3" : "pl-w-screen pl-h-screen !pl-bg-white dark:!pl-bg-dark-1 !pl-rounded-none pl-pt-4"}`}
            scrollbar={true}
        >
            <>
                <div className="pl-flex pl-flex-col pl-justify pl-gap-2 pl-mx-4 pl-pb-5">
                    {bookmarks.length ? bookmarks.map((bookmark: IBookmark) => (
                        <BookmarkCard {...bookmark} key={bookmark.id} />
                    )) : (
                        <div className="pl-flex pl-flex-col pl-justify-center pl-items-center pl-gap-4 pl-text-center">
                            <EmptyStateBookmarksIcon />
                            <p className="pl-text-[14px] pl-font-medium pl-text-secondary-900 dark:pl-text-dark-5">در حال حاضر هیج آیتمی ذخیره نشده است.</p>
                        </div>
                    )}
                </div>
                {conditions(ConditionName.isTouchScreenPortrait) && <TabNavigator />}
            </>
        </Popover>
    )
}

export default BookmarksPopover;